import posthog from "posthog-js";
import type { AnalyticsProperties } from "../types";

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com";
const SESSION_REPLAY_ENABLED = process.env.REACT_APP_POSTHOG_SESSION_REPLAY === "true";

let initialized = false;

function ensureInitialized(): void {
    if (!POSTHOG_KEY || initialized) return;
    initialized = true;

    posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        // Loaded eagerly but captures nothing until opt_in_capturing() is
        // called (see setConsent below) - avoids re-initializing the SDK on
        // every consent change.
        opt_out_capturing_by_default: true,
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: false,
        // Cost control: no person profile (and no PostHog billing "person")
        // is created for purely anonymous events, only once a user is
        // identify()'d.
        person_profiles: "identified_only",
        disable_session_recording: !SESSION_REPLAY_ENABLED,
        session_recording: SESSION_REPLAY_ENABLED
            ? {
                  maskAllInputs: true,
                  maskTextSelector: "*",
              }
            : undefined,
    });
}

export function setConsent(granted: boolean): void {
    if (!POSTHOG_KEY) return;
    ensureInitialized();
    if (granted) {
        posthog.opt_in_capturing();
    } else {
        posthog.opt_out_capturing();
    }
}

export function pageview(path: string): void {
    if (!POSTHOG_KEY) return;
    posthog.capture("$pageview", { $current_url: path });
}

export function event(name: string, properties: AnalyticsProperties): void {
    if (!POSTHOG_KEY) return;
    posthog.capture(name, properties);
}

export function identify(userId: string): void {
    if (!POSTHOG_KEY) return;
    posthog.identify(userId);
}

export function reset(): void {
    if (!POSTHOG_KEY) return;
    posthog.reset();
}
